
import {
  FETCH_REPORTS_START,
  FETCH_REPORTS_SUCCESS,
  FETCH_REPORTS_FAILURE,
} from "./actionTypes";


const initialState = {
  loading: false,
  data: {},
  stats: 0,
  docs: [],
  grandTotal: null,
  requestId: null,
  error: null,
  // totalDocs: 0,
  // docs: [],
  // page: 1
};
const reportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REPORTS_START:
      state = {
        ...initialState,
        loading: true,
        requestId: action.requestId,
      };
      break;
    case FETCH_REPORTS_SUCCESS:
      if (action.requestId !== state.requestId) return state;
      state = {
        ...state,
        loading: false,
        ...action.payload,
      };
      break;
    case FETCH_REPORTS_FAILURE:
      if (action.requestId !== state.requestId) return state;
      state = {
        ...initialState,
        requestId: action.requestId,
        error: action.error
      };
      break;
    default:
      state = { ...state };

  }
  return state;
};
export default reportsReducer;
